var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbOther(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75C9.31334 13.75 9.16668 12.9617 9.16668 12.8333H7.33334C7.33334 13.6767 7.93834 15.1708 10.0833 15.51V16.5H11.9167V15.51C13.75 15.1983 14.6667 14.0158 14.6667 12.8333C14.6667 11.8067 14.19 10.0833 11 10.0833C9.16668 10.0833 9.16668 9.50583 9.16668 9.16667C9.16668 8.8275 9.80834 8.25 11 8.25C12.1917 8.25 12.2742 8.83667 12.2833 9.16667H14.1167C14.1043 8.54219 13.8797 7.94054 13.4798 7.46071C13.08 6.98088 12.5287 6.65146 11.9167 6.52667V5.5H10.0833V6.49917C8.25001 6.80167 7.33334 7.98417 7.33334 9.16667C7.33334 10.1933 7.81001 11.9167 11 11.9167C12.8333 11.9167 12.8333 12.54 12.8333 12.8333C12.8333 13.1267 12.265 13.75 11 13.75Z",
    fill: "url(#paint0_linear_1289_2364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58334 1.8335H1.83334V3.66683H3.66668V19.2502C3.66668 19.4933 3.76325 19.7264 3.93516 19.8983C4.10707 20.0703 4.34023 20.1668 4.58334 20.1668H17.4167C17.6598 20.1668 17.893 20.0703 18.0649 19.8983C18.2368 19.7264 18.3333 19.4933 18.3333 19.2502V3.66683H20.1667V1.8335H4.58334ZM16.5 18.3335H5.50001V3.66683H16.5V18.3335Z",
    fill: "url(#paint1_linear_1289_2364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1289_2364",
    x1: 11,
    y1: 5.5,
    x2: 11,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63363A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1289_2364",
    x1: 11,
    y1: 1.8335,
    x2: 11,
    y2: 20.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63363A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbOther);
export default __webpack_public_path__ + "static/media/dbOther.e0fb0b98d76df5ff654c6c58834aa90d.svg";
export { ForwardRef as ReactComponent };